/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, CircularProgress, Grid, styled, TextField, Typography } from "@mui/material";
import { ActionStage, ArchitecturalCode, ItemStatus, Responsibility, Scope } from "../../../../common/const";
import { useState } from "react";
import { apiRequest } from "../../../../common/common";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 13
}));

export default function ProductDetails({
    projectData,
    selectedProduct,
    item,
    setItem
}) {
    const productData = selectedProduct[0];
    const { user } = useSelector((state) => state.users);
    const [vendorData, setVendorData] = useState([]);
    const [vendorPage, setVendorPage] = useState(1);
    const [isVendorAvailable, setIsVendorAvailable] = useState(true);
    const [vendorLoading, setVendorLoading] = useState(false);
    const [budgetLoading, setBudgetLoading] = useState(false);
    const [budgetData, setBudgetData] = useState([]);

    const getVendorData = async (pageNo, searchText) => {
        try {
            setVendorLoading(true);
            const response = await apiRequest('get', `/product-provider?type=vender&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsVendorAvailable(true);
                const array = [...vendorData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setVendorData(uniqueArray);
                setVendorLoading(false);
            } else {
                setIsVendorAvailable(false);
                setVendorLoading(false);
            }
        } catch (error) {
            setVendorLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getBudget = async () => {
        try {
            setBudgetLoading(true);
            const response = await apiRequest('get', `/budget?projectId=${projectData?.project_id}&pageNo=1&pageSize=100`);
            const { data } = response.data;
            if (data?.length > 0) {
                setBudgetData(data);
            }
            setBudgetLoading(false);
        } catch (error) {
            setBudgetLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (projectData) {
            getVendorData(vendorPage);
            getBudget();
        }
    }, [projectData]);

    const loadNextVendor = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = vendorPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isVendorAvailable) {
            setVendorPage(numberOfPages);
            await getVendorData(numberOfPages);
        }
    };

    return (
        <Box style={{ padding: '0px 15px 0px 15px' }}>
            <Typography variant='body1' style={{ fontWeight: 'bold' }}>Item Details</Typography>
            <Typography variant='body2'>Basic Item information and product IDs</Typography>
            <Grid container mt={1}>
                <Grid item xs={12} sm={12} md={6} lg={3} style={{ border: '1px solid lightgray', padding: '10px' }}>
                    <center>
                        <img
                            src={productData?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${productData?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                            style={{ width: 100 }}
                            alt="img"
                        />
                    </center>
                    <Typography variant='body1' style={{ fontWeight: 'bold', margin: '5px 0px' }}>{productData?.model}</Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Numeric ID:</DemoTypo>
                        <DemoTypo variant="body2">{`${productData?.is_customer_product ? `C-${productData?.alternate_id}`: `${productData?.category?.["sku_no"] || ''}${productData?.sub_category?.["sku_no"] || ''}-${String(productData?.["numaric_sku"]).padStart(3, '0')}`}`}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Alphanumeric ID:</DemoTypo>
                        <DemoTypo variant="body2">{`${productData?.is_customer_product ? `C-${productData?.alternate_id}`: `${productData?.category?.["prefix"] || ''}${productData?.sub_category?.["prefix"] || ''}-${String(productData?.["numaric_sku"]).padStart(3, '0')}`}`}</DemoTypo>
                    </Box>
                    <Box display="flex" gap={1}>
                        <DemoTypo variant="body2">Category:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.category?.name || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" gap={1}>
                        <DemoTypo variant="body2">SubCategory:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.["sub_category"]?.name || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" gap={1}>
                        <DemoTypo variant="body2">Manufacturer:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.manufacturer?.name || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Catalog #:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.catalog || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Price:</DemoTypo>
                        <DemoTypo variant="body2">{`₹ ${Intl.NumberFormat('en-IN').format(productData?.list_price)}`}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={9} style={{ paddingLeft: '10px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={Scope.find((c) => c.value === item?.scope) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={Scope}
                                clearIcon={null}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        scope: newValue?.value || null,
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Scope" name="Scope" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={ItemStatus.find((c) => c.value === item?.status) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={ItemStatus}
                                clearIcon={null}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        status: newValue?.value || null,
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Status" name="Status" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={ActionStage.find((c) => c.value === item?.stage) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                clearIcon={null}
                                options={ActionStage}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        stage: newValue?.value || null,
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Action Stage" name="Action Stage" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={Responsibility.find((c) => c.value === item?.product_data?.furnish_responsibility) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={Responsibility}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        product_data: {
                                            ...prevData.product_data,
                                            furnish_responsibility: newValue?.value || null,
                                        }
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Furnish Responsibility" name="Furnish Responsibility" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={Responsibility.find((c) => c.value === item?.product_data?.install_responsibility) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={Responsibility}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        product_data: {
                                            ...prevData.product_data,
                                            install_responsibility: newValue?.value || null,
                                        }
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Install Responsibility" name="Install Responsibility" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={ArchitecturalCode.find((c) => c.value === item?.product_data?.architectural_code) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={ArchitecturalCode}
                                getOptionLabel={(option) => option?.name}
                                getOptionDisabled={(option) => ['8', '9', '10'].includes(option.value)}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        product_data: {
                                            ...prevData.product_data,
                                            architectural_code: newValue?.value || null
                                        }
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Architectural Code" name="Architectural Code" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={vendorData.find((c) => c.product_provider_id === item?.product_data?.vendor_id) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={vendorData}
                                getOptionLabel={(option) => option?.name}
                                ListboxProps={{
                                    onScroll: (event) => loadNextVendor(event),
                                }}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        product_data: {
                                            ...prevData.product_data,
                                            vendor_id: newValue?.product_provider_id || null,
                                            vendor: {
                                                name: newValue?.name
                                            }
                                        }
                                    }));
                                }}
                                onInputChange={(e) => {
                                    if (e) {
                                        if (e?.target?.value?.length >= 1) {
                                            setVendorData([]);
                                            setVendorPage(1);
                                            getVendorData(1, e?.target?.value);
                                        }
                                    }
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        fullWidth
                                        {...params}
                                        label="Vendor"
                                        name="Vendor"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Autocomplete
                                value={budgetData.find((c) => c.budget_id === item?.budget_id) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={budgetData}
                                getOptionLabel={(option) => option?.budget_name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        budget_id: newValue?.budget_id || null
                                    }));
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        fullWidth
                                        {...params}
                                        label="Budget"
                                        name="Budget"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {budgetLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}